import React, { Component } from 'react'
import Slider from 'react-slick'
import PublicationList from '../components/media/PublicationList'
import { withNamespaces } from 'react-i18next'

function Media({ language, t, publications }) {
  // constructor(props) {
  // 	super(props);
  // 	this.next = this.next.bind(this);
  // 	this.previous = this.previous.bind(this);
  // }
  const next = () => {
    this.slider.slickNext()
  }
  const previous = () => {
    this.slider.slickPrev()
  }
  const settings = {
    speed: 700,
    autoplay: true,
    slidesToShow: 1,
  }

  return (
    <div className='wrapper'>
      <div className='media-bg'>
        <div className='media-content'>
          {/* Intro */}
          <h2 id='videos'>{t('Bassothek')}</h2>

          {/* Youtube */}
          <div className='youtube-section'>
            <h3>Double Bass Concertos</h3>
            <div class='elfsight-app-08c32c1d-82fb-4f8f-a0df-1ce3bdace064' />

            <h3>Double Bass and Piano</h3>
            <div class='elfsight-app-57d66bb0-c365-4a24-acd9-393d4cd51fe3' />

            <h3>Chamber music with Double Bass</h3>
            <div class='elfsight-app-712e4c7d-7428-47a3-a7b7-aa47cf2e4ff1' />

            <h3>Double Bass Solo</h3>
            <div class='elfsight-app-be7ba593-82d8-4817-b53c-1295a6b9f031' />
          </div>

          {/* Diskographie & Publikationen */}
          <div id='disko' />
          <div className='media-grid-2'>
            {/* Diskographie */}
            <div className='item'>
              <h2>{t('publications')}</h2>
              <p className='desc' />
              <div className='disko-grid'>
                <PublicationList publications={publications} />
              </div>
            </div>

            {/* Publikationen */}
            <div className='item'>
              <h2>{t('discography')}</h2>
              <p className='desc' />

              <div className='cover-grid'>
                <div className='item'>
                  <img src='./img/double-bass-cover.jpg' alt='' />
                  <p className='cover-desc'>
                    <a
                      href='https://bc.lnk.to/bassrhapsodyWE/applemusic'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://bc.lnk.to/bassrhapsodyWE/amazonmp3'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://bc.lnk.to/bassrhapsodyWE/spotify'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>

                <div className='item'>
                  <img src='./img/cover-chapters.jpg' alt='' />
                  <p className='cover-desc'>
                    <a
                      href='https://music.apple.com/de/album/chapters-a-double-bass-story/1660916881'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://www.amazon.de/music/player/albums/B0BQMS8C94'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://open.spotify.com/album/4YOe3fDnuhAfZ6xJfW9XUi?si=j2Pa2zZZTKawc7mtb5pCVg'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>

                <div className='item'>
                  <img src='./img/cover-2.jpg' alt='' />
                  <p className='cover-desc'>
                    <a
                      href='https://music.apple.com/de/album/1580019213?ign-itscg=30440&ign-itsct=catchall_p1'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://www.amazon.de/dp/B09BZW8V4J?tag=Edel_lf_berlinclassics-21&ie=UTF8&linkCode=as2&ascsubtag=b862579e673740243a2a05ca9e6139b4'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://open.spotify.com/album/68huNK0JnHJxeGpzTDGnO1?si=4FofnDvKToW9mw5Zsi1l6A'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>

                <div className='item'>
                  <img src='./img/cover-1.jpg' alt='' />
                  <p className='cover-desc'>
                    <a
                      href='https://music.apple.com/de/album/gassenhauer/1141386005?app=itunes&ign-mpt=uo%3D4'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://www.amazon.de/Gassenhauer-Karner-Vera/dp/B01GDGCELM/ref=sr_1_1?s=music&ie=UTF8&qid=1469040039&sr=1-1&keywords=Gassenhauer+Karner'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://open.spotify.com/album/4YQ8vvYvINJ4ShrCqNHReR'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>

                <div className='item'>
                  <img
                    src='./img/anne-sophie-mutter-bach-bologne-previn-vivaldi-williams.jpg'
                    alt=''
                  />
                  <p className='cover-desc'>
                    <a
                      href='https://geo.itunes.apple.com/de/album/bach+bologne+previn+vivaldi+williams/id1706847715?at=1000lMJJ&ct=0028948652563_anne-sophie+mutter_bach%2C+bologne%2C+previn%2C+vivaldi%2C+williams_www.universal-music.de&app=music'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://www.amazon.de/-/en/Mutter-S-Virtuosi-Anne-Sophie/dp/B0CK1BR6BK/ref=sr_1_1?crid=399WM0PR1763U&keywords=BACH+•+BOLOGNE+•+PREVIN+•+VIVALDI+•+WILLIAMS+%2F+Mutter&qid=1696563601&sprefix=bach+bologne+previn+vivaldi+willia'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://open.spotify.com/album/3MoCHGDjhVrZuXM3Kj6V49'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>

                <div className='item'>
                  <img src='./img/classical-brein.jpg' alt='' />
                  <p className='cover-desc'>
                    <a
                      href='https://music.apple.com/ca/album/classical-brein/1638873711'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://www.amazon.de/Classical-Brein-Breinschmid-Tjeknavorian-Br%C3%BCggemann/dp/B0B5MX4SVV/ref=sr_1_2?qid=1674742584&s=music&sr=1-2'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://open.spotify.com/album/4AuW84dWJ1Qw3rgNYGtxBM'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>

                <div className='item'>
                  <img src='./img/cover-3.jpg' alt='' />
                  <p className='cover-desc'>
                    <a
                      href='https://music.apple.com/ch/album/astor-piazzolla-100/1585228582'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {' '}
                      Apple Music{' '}
                    </a>
                    |{' '}
                    <a
                      href='https://www.amazon.de/Piazzolla-Kraayenhof-Oliver-Schnyder-Rudens/dp/B09FN31S2Z/ref=sr_1_2?__mk_de_DE=ÅMÅŽÕÑ&dchild=1&keywords=piazzolla+100&qid=1633170363&sr=8-2'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Amazon
                    </a>{' '}
                    |{' '}
                    <a
                      href='https://open.spotify.com/album/7jtMn1ZjBCUfFMTEDZGDFv?si=41cSB-rwTZWD0E29Q6BtBw&dl_branch=1'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Spotify
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Soundcloud 
					<div id="soundcloud" />
					<div className="soundcloud-section">
						<div className="item align-vertical fade-in" data-emergence="hidden">
							<div className="container">
								<h3>Soundcloud</h3>
							</div>
						</div>
						<div className="item">
							<iframe
								src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/279899708&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true"
								scrolling="no"
								width="100%"
								height="450"
								frameborder="no"
							/>
						</div>
					</div>
					*/}

          {/* Social Media */}
          <div id='social' />
          <div className='social-media-content'>
            <h2>Social Media</h2>
            <div class='elfsight-app-3afd82f4-a519-45a6-b9b6-ea985d68063a' />
            <div className='social-link-section align-horizontal'>
              <a
                href='https://www.youtube.com/user/bassowagner'
                target='_blank'
                rel='noreferrer'
              >
                <svg
                  width='513'
                  height='388'
                  viewBox='0 0 513 388'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M334.809 170.992L221.695 109.102C215.191 105.543 207.504 105.676 201.129 109.453C194.75 113.234 190.945 119.914 190.945 127.328V250.047C190.945 257.426 194.727 264.094 201.062 267.879C204.371 269.856 208.039 270.848 211.715 270.848C215.082 270.848 218.457 270.016 221.562 268.344L334.68 207.52C341.395 203.906 345.586 196.926 345.617 189.297C345.645 181.668 341.504 174.656 334.809 170.992V170.992ZM220.949 234.609V142.891L305.488 189.149L220.949 234.609Z'
                    fill='black'
                  />
                  <path
                    d='M508.234 91.5273L508.211 91.293C507.777 87.1719 503.461 50.5156 485.641 31.8711C465.043 9.94141 441.691 7.27734 430.461 6C429.531 5.89453 428.68 5.79688 427.918 5.69531L427.023 5.60156C359.336 0.679688 257.113 0.0078125 256.09 0.00390625L256 0L255.91 0.00390625C254.887 0.0078125 152.664 0.679688 84.3672 5.60156L83.4648 5.69531C82.7383 5.79297 81.9375 5.88281 81.0664 5.98438C69.9648 7.26562 46.8633 9.93359 26.207 32.6562C9.23438 51.1016 4.32812 86.9727 3.82422 91.0039L3.76562 91.5273C3.61328 93.2422 0 134.066 0 175.051V213.363C0 254.348 3.61328 295.172 3.76562 296.891L3.79297 297.148C4.22656 301.203 8.53906 337.188 26.2773 355.84C45.6445 377.035 70.1328 379.84 83.3047 381.348C85.3867 381.586 87.1797 381.789 88.4023 382.004L89.5859 382.168C128.668 385.887 251.203 387.719 256.398 387.793L256.555 387.797L256.711 387.793C257.734 387.789 359.953 387.117 427.641 382.195L428.535 382.102C429.391 381.988 430.352 381.887 431.406 381.777C442.445 380.605 465.422 378.172 485.793 355.758C502.766 337.309 507.676 301.438 508.176 297.41L508.234 296.887C508.387 295.168 512.004 254.348 512.004 213.363V175.051C512 134.066 508.387 93.2461 508.234 91.5273V91.5273ZM481.996 213.363C481.996 251.297 478.684 290.363 478.371 293.949C477.098 303.828 471.922 326.523 463.652 335.512C450.902 349.539 437.805 350.93 428.242 351.941C427.086 352.063 426.016 352.18 425.047 352.301C359.578 357.035 261.215 357.762 256.684 357.789C251.602 357.715 130.859 355.867 92.9688 352.348C91.0273 352.031 88.9297 351.789 86.7188 351.539C75.5039 350.254 60.1523 348.496 48.3477 335.512L48.0703 335.215C39.9453 326.75 34.918 305.527 33.6406 294.066C33.4023 291.355 30.0039 251.828 30.0039 213.363V175.051C30.0039 137.16 33.3086 98.1367 33.6289 94.4766C35.1484 82.8398 40.4219 61.5195 48.3477 52.9023C61.4883 38.4492 75.3438 36.8477 84.5078 35.7891C85.3828 35.6875 86.1992 35.5937 86.9531 35.4961C153.375 30.7383 252.445 30.0313 256 30.0039C259.555 30.0273 358.59 30.7383 424.422 35.4961C425.23 35.5977 426.113 35.6992 427.062 35.8086C436.488 36.8828 450.734 38.5078 463.809 52.4531L463.93 52.582C472.055 61.0469 477.082 82.6406 478.359 94.332C478.586 96.8906 481.996 136.504 481.996 175.051V213.363Z'
                    fill='black'
                  />
                </svg>
              </a>
              <a
                href='https://www.instagram.com/dominik_bass/'
                target='_blank'
                rel='noreferrer'
              >
                <svg
                  width='512'
                  height='512'
                  viewBox='0 0 512 512'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M373.406 0H138.594C62.1719 0 0 62.1719 0 138.594V373.41C0 449.828 62.1719 512 138.594 512H373.41C449.828 512 512 449.828 512 373.41V138.594C512 62.1719 449.828 0 373.406 0V0ZM481.984 373.41C481.984 433.277 433.277 481.984 373.406 481.984H138.594C78.7227 481.984 30.0156 433.277 30.0156 373.41V138.594C30.0156 78.7227 78.7227 30.0156 138.594 30.0156H373.41C433.277 30.0156 481.984 78.7227 481.984 138.594V373.41Z'
                    fill='black'
                  />
                  <path
                    d='M256 116.004C178.805 116.004 116.004 178.805 116.004 256C116.004 333.195 178.805 395.996 256 395.996C333.195 395.996 395.996 333.195 395.996 256C395.996 178.805 333.195 116.004 256 116.004V116.004ZM256 365.98C195.359 365.98 146.02 316.645 146.02 256C146.02 195.359 195.359 146.02 256 146.02C316.645 146.02 365.98 195.359 365.98 256C365.98 316.645 316.645 365.98 256 365.98V365.98Z'
                    fill='black'
                  />
                  <path
                    d='M399.344 66.2852C376.531 66.2852 357.977 84.8438 357.977 107.652C357.977 130.465 376.531 149.023 399.344 149.023C422.156 149.023 440.715 130.465 440.715 107.652C440.715 84.8398 422.156 66.2852 399.344 66.2852ZM399.344 119.004C393.086 119.004 387.992 113.91 387.992 107.652C387.992 101.391 393.086 96.3008 399.344 96.3008C405.605 96.3008 410.699 101.391 410.699 107.652C410.699 113.91 405.605 119.004 399.344 119.004Z'
                    fill='black'
                  />
                </svg>
              </a>
              <a
                href='https://www.facebook.com/dominikemanuelwagner'
                target='_blank'
                rel='noreferrer'
              >
                <svg
                  width='292'
                  height='511'
                  viewBox='0 0 292 511'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M180 511H98.0078C84.3125 511 73.1719 499.859 73.1719 486.164V301.227H25.3359C11.6406 301.227 0.5 290.082 0.5 276.391V197.145C0.5 183.449 11.6406 172.309 25.3359 172.309H73.1719V132.625C73.1719 93.2773 85.5273 59.8008 108.898 35.8203C132.375 11.7305 165.184 -1 203.777 -1L266.309 -0.898438C279.98 -0.875 291.102 10.2656 291.102 23.9375V97.5156C291.102 111.211 279.965 122.352 266.273 122.352L224.172 122.367C211.332 122.367 208.063 124.941 207.363 125.73C206.211 127.039 204.84 130.738 204.84 140.953V172.305H263.109C267.496 172.305 271.746 173.387 275.398 175.426C283.277 179.828 288.176 188.152 288.176 197.148L288.145 276.395C288.145 290.082 277.004 301.223 263.309 301.223H204.84V486.164C204.84 499.859 193.695 511 180 511V511ZM103.188 480.984H174.82V287.789C174.82 278.645 182.262 271.207 191.402 271.207H258.129L258.156 202.324H191.398C182.258 202.324 174.82 194.887 174.82 185.742V140.953C174.82 129.227 176.012 115.891 184.863 105.867C195.559 93.75 212.414 92.3516 224.164 92.3516L261.086 92.3359V29.1094L203.754 29.0156C141.73 29.0156 103.188 68.7188 103.188 132.625V185.742C103.188 194.883 95.75 202.324 86.6094 202.324H30.5156V271.207H86.6094C95.75 271.207 103.188 278.645 103.188 287.789V480.984ZM266.25 29.1172H266.254H266.25Z'
                    fill='black'
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withNamespaces()(Media)
